import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["container"]

  connect() {
    // Automatically handle click-outside-to-close
    this.boundHandleClick = this.handleOutsideClick.bind(this)
    this.element.addEventListener('click', this.boundHandleClick)
  }

  disconnect() {
    this.element.removeEventListener('click', this.boundHandleClick)
  }

  close() {
    this.element.remove()
  }

  handleOutsideClick(event) {
    // Close if clicking on the modal backdrop (not content)
    if (event.target === this.element) {
      this.close()
    }
  }
}
